// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2bGVl","form":"styles_form__2KB31"};